import React from 'react'
import Spinner from 'react-bootstrap/Spinner';

const PageLoading = () => {
    return (
        <div className="d-flex justify-content-center align-items-center" style={{height: "100vh"}}>
            <div className='d-flex justify-content-center'>
                <Spinner animation="grow" as="div" className='ms-2' />
                <Spinner animation="grow" as="span" className='ms-2 text-primary' />
                <Spinner animation="grow" as="p" className='ms-2 text-danger' />
                <Spinner animation="grow" as="span" className='ms-2 text-primary' />
                <Spinner animation="grow" as="div" className='ms-2' />
                <Spinner animation="grow" as="div" className='ms-2 text-danger' />
            </div>
        </div>
    )
}

export default PageLoading